// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Oa0-F","large":"styles_large__dQirV"};